import React from 'react';

const PrivacyPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white shadow-lg rounded-lg overflow-hidden">
          <div className="bg-primary-600 px-6 py-4">
            <h1 className="text-3xl font-bold text-white">Privacy Policy</h1>
            <p className="text-primary-100 mt-2">Last Updated: December 15, 2023</p>
          </div>
          
          <div className="px-6 py-8 prose prose-lg max-w-none">
            <h2>1. Introduction</h2>
            <p>Crawly Carl ("we," "our," or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our web scraping API service, Chrome extension, or any other services we provide (collectively, the "Services").</p>
            <p>Please read this Privacy Policy carefully. If you do not agree with the terms of this Privacy Policy, please do not access or use our Services. By using our Services, you consent to the collection, use, and disclosure of information in accordance with this Privacy Policy.</p>

            <h2>2. Information We Collect</h2>
            <p>We collect several types of information from and about users of our Services:</p>
            
            <h3>2.1 Personal Information</h3>
            <p>When you sign up for and use our Services, we may collect personally identifiable information, such as:</p>
            <ul>
              <li>Name</li>
              <li>Email address</li>
              <li>Billing information</li>
              <li>Company information (if applicable)</li>
            </ul>
            
            <h3>2.2 Usage Information</h3>
            <p>We may also collect information about how you use our Services, including:</p>
            <ul>
              <li>API usage statistics</li>
              <li>URLs requested for scraping</li>
              <li>Tool usage patterns</li>
              <li>IP address</li>
              <li>Browser type and version</li>
              <li>Operating system</li>
              <li>Timestamps of API requests</li>
            </ul>
            
            <h3>2.3 Web Scraping Data</h3>
            <p>When you use our Services to scrape websites, we process and temporarily store:</p>
            <ul>
              <li>URLs you request to scrape</li>
              <li>The target data you specify</li>
              <li>Data extracted from websites as per your request</li>
              <li>Metadata related to scraping operations</li>
            </ul>
            <p>We do not permanently store the data extracted from websites on your behalf unless specifically required as part of our Services (such as for caching purposes).</p>

            <h2>3. How We Use Your Information</h2>
            <p>We may use the information we collect for various purposes, including to:</p>
            <ul>
              <li>Provide, maintain, and improve our Services</li>
              <li>Process and complete transactions</li>
              <li>Track and analyze usage patterns for improving our Services</li>
              <li>Communicate with you about service updates, offers, and promotions</li>
              <li>Respond to your requests, inquiries, or support needs</li>
              <li>Prevent fraudulent use of our Services</li>
              <li>Monitor compliance with our Terms of Service</li>
              <li>Develop new features and functionality</li>
            </ul>

            <h2>4. Sharing Your Information</h2>
            <p>We may share your information in the following situations:</p>
            
            <h3>4.1 Service Providers</h3>
            <p>We may share your information with third-party vendors, service providers, contractors, or agents who perform services for us or on our behalf, including cloud hosting providers, payment processors, and analytics services.</p>
            
            <h3>4.2 Analytics</h3>
            <p>We may use third-party analytics providers to help analyze how users use our Services. These analytics providers may use cookies, web beacons, and other technologies to collect and analyze information about your use of our Services.</p>
            
            <h3>4.3 Legal Requirements</h3>
            <p>We may disclose your information if required to do so by law or in response to valid requests by public authorities (e.g., a court or government agency).</p>
            
            <h3>4.4 Business Transfers</h3>
            <p>We may share or transfer your information in connection with, or during negotiations of, any merger, sale of company assets, financing, or acquisition of all or a portion of our business to another company.</p>
            
            <h3>4.5 With Your Consent</h3>
            <p>We may disclose your information for any other purpose with your consent.</p>

            <h2>5. Data Security</h2>
            <p>We have implemented appropriate technical and organizational security measures designed to protect the security of any personal information we process. However, despite our safeguards and efforts to secure your information, no electronic transmission over the Internet or information storage technology can be guaranteed to be 100% secure.</p>
            <p>We use data encryption, secure API authentication, and other security measures to protect your data. Our API keys are transmitted and stored securely, and usage is monitored for suspicious activity.</p>

            <h2>6. Your Rights and Choices</h2>
            <p>Depending on your location, you may have certain rights regarding your personal information, including:</p>
            <ul>
              <li>The right to access personal information we hold about you</li>
              <li>The right to request correction of inaccurate information</li>
              <li>The right to request deletion of your personal information</li>
              <li>The right to object to or restrict processing of your personal information</li>
              <li>The right to data portability</li>
              <li>The right to withdraw consent where processing is based on consent</li>
            </ul>
            <p>To exercise these rights, please contact us at privacy@crawlycarl.com.</p>

            <h2>7. Contact Us</h2>
            <p>If you have any questions, concerns, or requests regarding this Privacy Policy or our privacy practices, please contact us at:</p>
            
            <div className="bg-gray-100 p-4 rounded-lg mt-4">
              <p><strong>Email:</strong> privacy@crawlycarl.com</p>
              <p><strong>Address:</strong> Crawly Carl<br />
              1234 Market Street<br />
              San Francisco, CA 94103</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPage;